import { HttpEventType } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MenuItem, MessageService } from 'primeng/api';
import { TableModule } from "primeng/table";
import { UploadService } from '../../services/upload/upload.service';
import { Table } from 'primeng/table';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { environment } from '../../../environments/environment';
@Component({
  standalone: false,
  selector: 'app-upload-document',
  templateUrl: './upload-document.component.html'
})
export class UploadDocumentComponent implements OnInit {
  // @Input() documentsArray!: FormArray;
  @Output() uploadData = new EventEmitter<any>(); // emit to parent
  @Output() onLazyLoadData = new EventEmitter<{ page: number; search?: string }>();
  @Output() documentEdited = new EventEmitter<any>();
  @Output() documentDeleted = new EventEmitter<any>();
  @Output() finalizeDocuments = new EventEmitter<any>();
  @Input() isEditable: boolean = false;
  @Input() title: string = 'Document Management';  
  @Input() showSearch: boolean = true; // default is true
  @Input() dmsFiles: any[] = []; // ✅ Data from parent
  /** When true, use only parent dmsFiles and do not fetch from API (e.g. AON page with SOC/SOTR merged in). */
  @Input() useParentDmsFiles: boolean = false;
  @Input() isFinalizeVisible: boolean = false;
  @Input() isSaveVied: boolean = false;

  @Input() url: string ='/transaction/dms/files/';
  @Input() postfix: string = 'proposal_step';
   first = 0;
  searchText: string = '';
  baseUrl: string = environment.APIUrl;
  editModeIndex: number | null = null;
  @Output() documentsChanged = new EventEmitter<FormArray>();
  // @ViewChild('dt') table: TableModule;
  @ViewChild('dt') dt!: Table; // ✅ PrimeNG Table reference
  uploadForm!: FormGroup;
  uploadProgress: number[] = [];
  actionMenuItems: MenuItem[] = [];
  selectedRow: any[] = [];
  selectedRowIndex!: number;
  fileCount = 0;
  displayDialog: boolean = false;
  selectedDoc: any = null;
  window = window;
  @Input() proposal_step: any;
  documentTypes = [
  { label: '.pdf', value: '.pdf' },
  { label: '.csv', value: '.csv' },
  { label: '.docx', value: '.docx' },
  { label: '.png', value: '.png' },
  { label: '.jpg', value: '.jpg' },
  { label: '.jpeg', value: '.jpeg' },
  { label: '.xlsx', value: '.xlsx' },
  { label: '.xls', value: '.xls' },
  { label: '.pptx', value: '.pptx' },
  { label: '.ppt', value: '.ppt' },
  { label: '.zip', value: '.zip' },
  ];
  // uploadForm!: FormGroup;  proposal_step: any;
  constructor(
    private fb: FormBuilder,
    private uploadService: UploadService,
    private messageService: MessageService,
    private ActivatedRoute: ActivatedRoute,
    private api: ApiService
  ) { 
    
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log(this.dmsFiles,"--------------------------------------")
   
    // Ensure form is initialized before trying to populate documents
    if (!this.uploadForm) {
      this.initForm();
    }
   
    if (changes['dmsFiles'] && this.dmsFiles.length > 0) {
      this.populateDocuments(this.dmsFiles);
    }
    
    // Handle isEditable changes
    if (changes['isEditable'] && this.uploadForm) {
      if (!this.isEditable) {
        this.uploadForm.disable();
      } else {
        this.uploadForm.enable();
      }
    }
  }
  getAllFile(){
    this.api.getAPI(`${this.url}?${this.postfix}=${this.proposal_step}`).subscribe((res: any) => {
      this.populateDocuments(res.data);
    // this.populateDocuments(res);
    })
  }
  ngOnInit(): void {
    if(!this.proposal_step){
      this.ActivatedRoute.queryParams.subscribe((params: any) => {
        this.proposal_step = params['step'];
      })}
    // Only initialize if not already initialized (e.g., from ngOnChanges)
    if (!this.uploadForm) {
      this.initForm();
    }
    this.actionMenuItems = [
      // { label: 'View Details', icon: 'pi pi-eye', command: (event) => this.viewDocument(this.selectedRow) },
      { label: 'Edit', icon: 'pi pi-pencil', command: (event) => this.editDocument(this.selectedRowIndex) },
      { label: 'Delete', icon: 'pi pi-trash', command: (event) => this.deleteDocument(this.selectedRowIndex) }
    ];
    // Removed duplicate initForm() call
    if (this.proposal_step && !this.useParentDmsFiles) {
      this.getAllFile();
    }
    if (this.useParentDmsFiles && this.dmsFiles?.length > 0) {
      this.populateDocuments(this.dmsFiles);
    }
    // Apply disabled state after form initialization
    if(!this.isEditable && this.uploadForm){
      this.uploadForm.disable();
    }
    console.log(this.dmsFiles,"--------------------------------------")

  }
  // Populate table rows from incoming dmsFiles data
  populateDocuments(docs: any[]) {
    // Ensure form is initialized before accessing documentsArray
    if (!this.uploadForm) {
      this.initForm();
    }
    this.documentsArray.clear();
    docs.forEach((doc) => {
      this.documentsArray.push(this.fb.group({
        id: [doc.id || null],
        name: [doc.name || '', Validators.required],
        description: [doc.description || ''],
        type: [doc.type_document || ''],
        // 👇 Correct mapping for uploaded date
        date: [doc.uploaded_at ? doc.uploaded_at.split('T')[0] : ''],
        file: [doc.file || null],
        is_approved: [doc.is_approved || false],
        document_flag: [doc.document_flag || false],
        [this.postfix]: [doc[this.postfix] || null]

      }));
    });

    this.fileCount = this.documentsArray.length;
    
    // Re-apply disabled state after populating documents
    if (!this.isEditable && this.uploadForm) {
      this.uploadForm.disable();
    }
  }

  /** Initialize form */
  initForm(): void {
    this.uploadForm = this.fb.group({
      documents: this.fb.array([]),
    });
    this.addDocument();
    this.updateDocuments();
  }
  /** Getter for documents FormArray */
  get documentsArray(): FormArray<FormGroup> {
    return this.uploadForm.get('documents') as FormArray<FormGroup>;
  }
  /** Names that must stay readonly (PDS/PRU for idex, SOTR/SOC for revenue) */
  isMandatoryDocName(value: string): boolean {
    const name = (value || '').toUpperCase().trim();
    return name === 'PDS' || name === 'PRU' || name === 'SOTR' || name === 'SOC';
  }
  /** Add document row */
  addDocument(): void {
    const docGroup = this.fb.group({
      name: ['', Validators.required],
      description: [''],
      type: [''],
      date: [new Date().toISOString().substring(0, 10)],
      file: [null]
    });
    this.documentsArray.push(docGroup);
    this.uploadProgress.push(0);
  }

  // get docs(): FormArray {
  //   return this.uploadForm.get('documentsArray') as FormArray;
  // }

  /** Increment counter and add rows */
  incrementCount(): void {
    this.fileCount++;
    this.updateDocuments();
  }

  /** Decrement counter and update rows */
  decrementCount(): void {
    if (this.fileCount > 0) {
      this.fileCount--;
      this.updateDocuments();
    }
  }
  /** Update table rows when count changes */
  updateDocuments(): void {
    const docsArray = this.uploadForm.get('documents') as FormArray;

    // Add rows if needed
    while (docsArray.length < this.fileCount) {
      docsArray.push(
        this.fb.group({
          name: [''],
          description: [''],
          type: [''],
          date: [new Date().toISOString().substring(0, 10)],
          file: [null],
        })
      );
    }

    // Remove rows if needed
    while (docsArray.length > this.fileCount) {
      docsArray.removeAt(docsArray.length - 1);
    }

    this.uploadProgress = new Array(this.fileCount).fill(0);
  }

  res:any
  onFileSelect(event: any, index: number): void {
    const file = event.target.files[0];
    if (!file) return;

    const row = this.documentsArray.at(index) as FormGroup;
    if (!row) {
      console.error(`❌ No form group found at index ${index}`);
      return;
    }

    row.patchValue({ file });
    const data = row.value;
    if(!this.proposal_step){
      this.uploadData.emit(data);
      return;
    }
    const formData = new FormData();
    formData.append(this.postfix, this.proposal_step);
    formData.append('name', data.name);
    formData.append('type_document', data.type);
    formData.append('description', data.description);
    formData.append('file', data.file);
    this.res=null
   
    this.api.postAPI(this.url, formData).subscribe((res: any) => this.res=res);
   
       
        
      
  }
  // emitUploadData(): void {
  //   if (this.uploadForm.invalid) return;

  //   const data = {
  //     name: this.uploadForm.get('name')?.value,
  //     description: this.uploadForm.get('description')?.value,
  //     file: this.uploadForm.get('file')?.value
  //   };

  //   this.uploadData.emit(data);
  //   console.log('🚀 Emitting upload data:', data);
  // }

  // onFileSelect(event: any, index: number): void {
  //   const file = event.target.files[0];
  //   if (!file) return;

  //   const row = this.docs.at(index);
  //   row.patchValue({ file });

  //   this.uploadProgress[index] = 0;

  //   this.uploadService.uploadFile(file).subscribe({
  //     next: (event) => {
  //       if (event.type === HttpEventType.UploadProgress && event.total) {
  //         this.uploadProgress[index] = Math.round((100 * event.loaded) / event.total);
  //       } else if (event.type === HttpEventType.Response) {
  //         this.messageService.add({
  //           severity: 'success',
  //           summary: 'Upload Successful',
  //           detail: `${file.name} uploaded successfully`
  //         });
  //       }
  //     },
  //     error: () => {
  //       this.messageService.add({
  //         severity: 'error',
  //         summary: 'Upload Failed',
  //         detail: 'Error while uploading file'
  //       });
  //     }
  //   });
  // }

  // viewDocument(row: any) {
  //   if (row.get('file')?.value) {
  //     const url = URL.createObjectURL(row.get('file')?.value);
  //     window.open(url, '_blank');
  //   }
  // }
  // editDocument(index: number) {
  //   const group = this.documentsArray.at(index) as FormGroup;
  //   group.enable(); // just ensures editable
  // }

  // deleteDocument(index: number): void {
  //   this.documentsArray.removeAt(index);
  //   this.uploadProgress.splice(index, 1);

  //   // Update counter and hide table if needed
  //   this.fileCount = this.documentsArray.length;

  //   if (this.fileCount === 0) {
  //     this.updateDocuments(); // ensures form stays consistent
  //   }

  //   this.messageService.add({
  //     severity: 'info',
  //     summary: 'Deleted',
  //     detail: 'Document removed'
  //   });
  // }
  loadDataLazy(event: any) {
    this.first = event.first;
    const page = event.first / event.rows + 1;

    let searchTerm = this.searchText?.trim() || '';
    const payload: any = { page };
    if (searchTerm) {
      payload.search = searchTerm;
    }

    this.onLazyLoadData.emit(payload);
  }
  onEnterSearch(value: string) {
    this.searchText = value.trim();
    this.first = 0;
    this.loadDataLazy({ first: 0, rows: 10 });
  }
  onSearchInput(value: string) {
    this.searchText = value.trim();
    if (this.searchText === '') {
      this.first = 0;
      this.loadDataLazy({ first: 0, rows: 10 });
    }
  }
  clear(table: any, searchInput: HTMLInputElement): void {
    // Step 1: Clear the search input box
    searchInput.value = '';
    this.searchText = '';

    // Step 2: Reset internal paginator tracking
    this.first = 0;

    // Step 3: Clear table filters and pagination
    if (table) {
      table.clear();
      table.first = 0;
    }

    // Step 4: Manually trigger lazy load with page 1 and empty search
    const fakeEvent = { first: 0, rows: 10 };
    this.loadDataLazy(fakeEvent);
  }

  saveDocument(index: number): void {
    const row = this.documentsArray.at(index) as FormGroup;

    if (this.res?.success !== false) {
      const data = row.value;
      console.log('✅ Saved row:', data);
      this.messageService.add({
        severity: 'success',
        summary: 'Saved Successfully',
        detail: `Document "${data.name || 'Untitled'}" saved.`
      });
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Validation Error',
        detail: this.res.message || 'Please fill out required fields before saving.'
      });
    }
    this.uploadForm.reset();
    this.getAllFile()
  }
  
editDocument(index: number): void {
  const group = this.documentsArray.at(index) as FormGroup;

  if (this.editModeIndex === index) {
    // ✅ Save Mode
    if (group.valid) {
      const updatedData = group.value;
      const formData = new FormData();
      formData.append(this.postfix, this.proposal_step);
      formData.append('name', updatedData.name);
      formData.append('type_document', updatedData.type);
      formData.append('description', updatedData.description);
      if (updatedData.file instanceof File) {
        formData.append('file', updatedData.file);
      }
      if(!this.proposal_step){
        this.uploadData.emit(formData);
        return;
      }
      this.api.putAPI(this.url+group.get('id')?.value +'/', formData).subscribe((res: any) => {
        this.getAllFile()
        this.messageService.add({
          severity: 'success',
          summary: 'Updated',
          detail: `Document "${updatedData.name}" updated successfully.`,
        });
      })
      this.editModeIndex = null;
    } else {
      this.messageService.add({
        severity: 'warn',
        summary: 'Validation Error',
        detail: 'Please fill required fields before saving.',
      });
    }
  } else {
    // ✏️ Edit Mode
    this.editModeIndex = index;
  }
}

  /** DELETE document row */
  deleteDocument(index: number): void {
    const deletedDoc = this.documentsArray.at(index)?.value;

    if (!deletedDoc) return;

    if (this.isMandatoryDocName(deletedDoc.name)) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Cannot Delete',
        detail: `"${deletedDoc.name}" cannot be deleted as it is a required document.`
      });
      return;
    }

    if (confirm(`Are you sure you want to delete "${deletedDoc.name}"?`)) {
      if (deletedDoc.id) {
        // Perform DELETE API call if the document has an ID
        this.api.deleteAPI(this.url + deletedDoc.id + '/').subscribe({
          next: (res: any) => {
            this.documentsArray.removeAt(index);
            this.fileCount = this.documentsArray.length;

            this.messageService.add({
              severity: 'info',
              summary: 'Deleted',
              detail: `Document "${deletedDoc.name}" removed.`,
            });

            this.documentDeleted.emit(deletedDoc.id);
            if(this.proposal_step){
              this.getAllFile();
            }
          },
          error: (err: any) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Delete Failed',
              detail: err?.error || `Failed to delete "${deletedDoc.name}".`
            });
          }
        });
      } else {
        // If no ID, just remove from the form array
        this.documentsArray.removeAt(index);
        this.fileCount = this.documentsArray.length;

        this.messageService.add({
          severity: 'info',
          summary: 'Deleted',
          detail: `Document "${deletedDoc.name}" removed.`,
        });

        this.documentDeleted.emit(deletedDoc.id);
      }
    }
  }

  downloadDocument(row: FormGroup): void {
    const fileValue = row.get('file')?.value;
    console.log(fileValue,"--------------------------------------")

    if (!fileValue) {
      this.messageService.add({
        severity: 'warn',
        summary: 'No File',
        detail: 'No file available to download.'
      });
      return;
    }

    // Case 1: API file (string URL)
    if (typeof fileValue === 'string') {
      const link = document.createElement('a');
      link.href = fileValue.startsWith('http')
        ? fileValue
        : `${window.location.origin}${fileValue}`;
      link.download = fileValue.split('/').pop() || 'document';
      link.target = '_blank';
      link.click();
      this.messageService.add({
        severity: 'success',
        summary: 'Downloaded',
        detail: 'File download started.'
      });
    }
    // Case 2: Local File object
    else if (fileValue instanceof File) {
      const fileURL = URL.createObjectURL(fileValue);
      const link = document.createElement('a');
      link.href = fileURL;
      link.download = fileValue.name;
      link.click();
      URL.revokeObjectURL(fileURL);
      this.messageService.add({
        severity: 'success',
        summary: 'Downloaded',
        detail: `${fileValue.name} downloaded successfully.`
      });
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Invalid File',
        detail: 'Cannot download this file type.'
      });
    }
  }



}